<template>
  <Stack
    gap="1"
  >
    <MenuItem
      v-for="type in documentTypes"
      :key="type.id"
      :selected="alreadyPresentByName.includes(type.name)"
      :static="alreadyPresentByName.includes(type.name)"
      @click="handleItemSelection(type)"
    >
      {{ type.name }}
    </MenuItem>
  </Stack>
</template>

<script setup>
import { computed, defineEmits } from 'vue';
import { Stack, MenuItem } from '@stakeui';

const props = defineProps({
  documentTypes: {
    type: Array,
    default: () => [],
    required: true,
  },
  alreadyPresent: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['addition']);

// Using the name/document_type instead of the document_type_id because
// we want to handle custom names as well
const alreadyPresentByName = computed(() => props.alreadyPresent.map(el => el.document_type));

const handleItemSelection = documentType => {
  emit('addition', documentType);
};
</script>

<style scoped>
</style>
